import React, { Fragment, ReactElement } from "react";
import styled from "styled-components";
import Markdown from "react-markdown";
import Theme from "../../../styles/themes/interfaces/Theme";
import defaultTheme from "../../../styles/themes/default";

const MotiveringTitle = styled.p(
  ({ theme }) => `
  font-weight: bold;
  font-size: 14px;
  margin-left: ${theme.ptom(8)};
`
);

type MotiveringDivProps = {
  theme?: Theme;
  variant?: "bordered" | "accented";
};

const motiveringDivStyles = ({ theme, variant }: MotiveringDivProps): string => {
  theme = theme ? theme : defaultTheme;

  return `
    margin:0;
    
    /* Remove default margins from react-markdown generated paragraphs */
    & p {
      margin: 0;
    }
    
    ${variant === "accented" &&
      `
      background-color: #f5f5f5;
      padding: ${theme.ptom ? `${theme.ptom(12)} ${theme.ptom(12)}` : "0.16mm"};
      border-radius: 4px;
    `};
  `;
};


const StyledMarkdown = styled(Markdown)<MotiveringDivProps>(motiveringDivStyles);

type MotiveringsProps = {
  wens: string | (string | null)[] | null;
  advies: string | (string | null)[] | null;
  keuze: string | (string | null)[] | null;
};

export const Motivering = ({
  wens,
  advies,
  keuze,
}: MotiveringsProps): ReactElement => {

  return (
    <>
      {wens &&
        (!Array.isArray(wens) ||
          (Array.isArray(wens) &&
            wens.length > 0 &&
            !wens.every((w) => w === null || w === ""))) && (
          <>
            <MotiveringTitle>Wens</MotiveringTitle>
            {Array.isArray(wens)
              ? wens?.map((item, index, array) => (
                  <Fragment key={index}>
                    <StyledMarkdown variant="accented">{item || ''}</StyledMarkdown>
                    {index < array.length - 1 && <br />}
                  </Fragment>
                ))
              : <StyledMarkdown variant="accented">{wens || ''}</StyledMarkdown>}
          </>
        )}

      {advies &&
        (!Array.isArray(advies) ||
          (Array.isArray(advies) && advies.length > 0)) && (
          <>
            <MotiveringTitle>Advies</MotiveringTitle>
            {Array.isArray(advies)
              ? advies?.map((item, index, array) => (
                  <Fragment key={index}>
                    <StyledMarkdown variant="accented">{item || ''}</StyledMarkdown>
                    {index < array.length - 1 && <br />}
                  </Fragment>
                ))
              : <StyledMarkdown variant="accented">{advies || ''}</StyledMarkdown>}
          </>
        )}

      {keuze &&
        (!Array.isArray(keuze) ||
          (Array.isArray(keuze) && keuze.length > 0)) && (
          <>
            <MotiveringTitle>Keuze</MotiveringTitle>
            {Array.isArray(keuze)
              ? keuze?.map((item, index, array) => (
                  <Fragment key={index}>
                    <StyledMarkdown variant="accented">{item || ''}</StyledMarkdown>
                    {index < array.length - 1 && <br />}
                  </Fragment>
                ))
              : <StyledMarkdown variant="accented">{keuze || ''}</StyledMarkdown>}
          </>
        )}
    </>
  );
};
